import React from "react";
import { Link } from "react-router-dom";

const WebportfolioSection = ({
  logo,
  title,
  description,
  features,
  technologies,
  technologiesimage,
  buttontext,
  buttonlink,
  portfolioimage,
}) => {
  return (
    <div className="portfolio-section">
      <section className="d-flex align-items-center">
        <div className="container">
          <div className="portfolio-hero-section-main okbaju">
            <div className="row align-items-center">
              <div className="col-lg-5 portfolio-hero-content">
                {/* Logo */}
                <div className="portfolio-hero-logo mb-2">
                  <img src={logo} alt={title} className="portfolio-logo" />
                </div>

                {/* Main Heading */}
                <h1 className="portfolio-hero-main-title">{title}</h1>

                {/* Description */}
                <p className="portfolio-hero-description">{description}</p>

                {/* Feature List */}
                {features && features.length > 0 && (
                  <div className="portfolio-hero-features-list">
                    {features.map((item, index) => (
                      <div className="portfolio-feature-item" key={index}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                            fill="#FC7600"
                          />
                        </svg>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Technology Icons */}
                {technologies && technologies.length > 0 && (
                  <div className="portfolio-tech-icons-grid">
                    {technologies.map((tech, i) => (
                      <div className="portfolio-tech-icon-card" key={i}>
                        <img
                          src={
                            technologiesimage && technologiesimage[i]
                              ? technologiesimage[i]
                              : tech
                          }
                          alt={
                            typeof tech === "string"
                              ? tech
                              : tech.name || "Technology"
                          }
                          className="portfolio-tech-icon"
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* CTA Button */}
                <Link to={buttonlink}>
                  <button className="portfolio-hero-cta-btn">
                    {buttontext}
                  </button>
                </Link>
              </div>

              <div className="col-lg-7 hero-image text-center mt-5 mt-lg-0">
                <div className="portfolio-device-mockups">
                  <img
                    src={portfolioimage}
                    alt={title}
                    className="portfolio-hero-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebportfolioSection;
